/**
* @file 云直播设置页
*/
<template>
  <div class="p-live-setting">
    <div class="p-live-setting__operate">
      <plv-button @click="distributeLiveResource('add')">添加资源</plv-button>
      <plv-button @click="distributeLiveResource('recycle')">回收资源</plv-button>
    </div>
    <div class="p-live-setting-form">
      <div class="p-live-setting-form__title">资源分配</div>
      <plv-row type="flex">
        <plv-col>
          <plv-column>
            <plv-column-item prefix="当前计费方式">{{ form.chargeTypeDesc }}</plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col>
          <plv-column>
            <plv-column-item prefix="直播分钟数">{{ form.minutes }}</plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col :span="6">
          <plv-column>
            <plv-column-item prefix="连麦人数">
              <plv-select v-model="form.linkMicLimit" size="small">
                <plv-select-option
                  v-for="option of interactNumOptions"
                  :key="option.value"
                  :label="option.label"
                  :value="option.value"
                />
              </plv-select>
            </plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col>
          <plv-row>
            <plv-col :span="6">
              <plv-column>
                <plv-column-item class="p-live-setting__column-item" prefix="连麦分钟数">{{ form.linkMicMinutes }}</plv-column-item>
              </plv-column>
            </plv-col>
            <plv-col :span="8">
              <plv-column>
                <plv-column-item prefix="连麦清晰度">
                  <div class="p-clear-continuous-wheat">
                    <plv-select v-model="form.rtcMaxResolution" size="small">
                      <plv-select-option
                        v-for="option of rtcMaxResolutionOptions"
                        :key="option.value"
                        :label="option.label"
                        :value="option.value"
                      />
                    </plv-select>
                    <plv-checkbox
                      v-model="form.multiplexingEnabled"
                      :disabled="disableMultiplexingEnabled"
                      label="混流"
                      class="p-checkbox-multiplexing"
                    />
                  </div>
                </plv-column-item>
              </plv-column>
            </plv-col>
          </plv-row>
        </plv-col>
        <plv-col>
          <plv-column>
            <plv-column-item prefix="云导播台">{{ form.guideMinutes }}</plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col>
          <plv-column>
            <plv-column-item prefix="频道数">{{ form.maxChannels }}</plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col>
          <plv-column>
            <plv-column-item prefix="并发限制">{{ form.concurrent === -1 ? '无限制' : form.concurrent }}</plv-column-item>
          </plv-column>
        </plv-col>
        <plv-col>
          <plv-row>
            <plv-col :span="12">
              <plv-column>
                <plv-column-item prefix="视频创作（含数字人）">
                  {{ form.availableAiPPTVideoDigitalHumanDuration }}
                </plv-column-item>
              </plv-column>
            </plv-col>
            <plv-col :span="12">
              <plv-column>
                <plv-column-item prefix="视频创作（不含数字人）">
                  {{ form.availableAiPPTVideoDuration }}
                </plv-column-item>
              </plv-column>
            </plv-col>
          </plv-row>
        </plv-col>
      </plv-row>

      <live-system-setting ref="liveSystemSetting" />

      <plv-button class="p-live-setting_btn" @click="updateLivePackage">保存</plv-button>
    </div>
    <live-distribute ref="distributeDialog" :visible.sync="distributeDialogVisible" @updateSuccess="updateSuccess" />
  </div>
</template>

<script>
import { chargeTypeEnum } from '@/utils/type';
import accountInfoMixin from '@/mixins/accountInfo';
import LiveDistribute from './components/liveDistribute.vue';
import { mapState } from 'vuex';
import LiveSystemSetting from '@/component/liveSystemSetting/liveSystemSetting.vue';

let originalRtcMaxResolution = '';
export default {
  components: {
    LiveDistribute,
    LiveSystemSetting,
  },
  mixins: [accountInfoMixin],
  data() {
    const interactNumOptions = [];
    for (let i = 1; i <= 16; i++) {
      interactNumOptions.push({
        label: `1v${i}`,
        value: i,
      });
    }
    return {
      type: '',
      form: {
        chargeType: '',
        concurrent: '',
        minutes: '',
        linkMicLimit: 2,
        linkMicMinutes: '',
        guideMinutes: '',
        maxChannels: '',
        rtcMaxResolution: '',
        multiplexingEnabled: false,
        chargeTypeDesc: '', // 计费方式
        availableAiPPTVideoDigitalHumanDuration: 0,
        availableAiPPTVideoDuration: 0
      },
      distributeDialogVisible: false,
      interactNumOptions,
    };
  },
  computed: {
    ...mapState({
      overViewInfo: state => state.account.overViewInfo
    }),
    rtcMaxResolutionOptions() {
      return [
        { label: '180', value: '180' },
        { label: '360', value: '360' },
        { label: '720', value: '720' },
        { label: '1080', value: '1080' },
        { label: '1440', value: '1440' },
        { label: '2160', value: '2160' },
      ];
    },
    disableMultiplexingEnabled() {
      return !this.ynToBool(this.overViewInfo.multiplexingEnabled ?? 'N');
    },
  },

  created() {
    this.getLivePackage();
  },
  methods: {
    distributeLiveResource(type = 'add') {
      if (!this.isSetLiveSettingEnable) {
        this.$toast.error('需要开通直播套餐');
        return;
      }
      this.$refs.distributeDialog.open(type, this.form);
    },
    // eslint-disable-next-line sonarjs/cognitive-complexity
    async getLivePackage() {
      const { params: { id } } = this.$route;
      if (id) this.form.unionId = id;
      try {
        this.$emit('loading');
        const res = await this.$store.dispatch('account/getLivePackage', id);
        this.addedConCurrent = this.form.concurrent = res.concurrent ?? 0;
        this.form.chargeType = res.chargeType ?? '';
        this.form.minutes = res.minutes ?? 0;
        this.form.linkMicLimit = res.linkMicLimit ?? 0;
        this.form.linkMicMinutes = res.linkMicMinutes ?? 0;
        this.form.guideMinutes = res.guideMinutes ?? 0;
        this.form.rtcMaxResolution = res.rtcMaxResolution ?? this.overViewInfo.rtcMaxResolution;
        this.form.multiplexingEnabled = this.ynToBool(res.multiplexingEnabled);
        this.addedChannels = this.form.maxChannels = res.maxChannels ?? 0;
        this.form.chargeTypeDesc = res.chargeTypeDesc;
        originalRtcMaxResolution = res.rtcMaxResolution;

        this.form.availableAiPPTVideoDigitalHumanDuration = res.availableAiPPTVideoDigitalHumanDuration;
        this.form.availableAiPPTVideoDuration = res.availableAiPPTVideoDuration;

        if (res.chargeType === chargeTypeEnum.Minutes) {
          this.form.chargeType = chargeTypeEnum.Minutes;
        } else if (!res.chargeType) {
          this.form.chargeType = '';
        } else {
          this.form.chargeType = 'concurrent';
        }

        const checkedSettings = [];
        for (const key in res) {
          if (res[key] === 'Y') {
            checkedSettings.push(key);
          }
        }
        if (this.$refs.liveSystemSetting) {
          this.$refs.liveSystemSetting.$setSettings(checkedSettings);
        }
      } finally {
        this.$emit('cancelLoading');
      }

    },
    async updateLivePackage() {
      if (!this.form.unionId) return;
      if (!this.isSetLiveSettingEnable) {
        this.$toast.error('需要开通直播套餐');
        return;
      }
      this.$emit('loading');
      let form = {
        chargeType: this.form.chargeType,
        linkMicLimit: this.form.linkMicLimit,
        maxChannels: this.form.maxChannels,
        unionId: this.form.unionId,
        linkMicMinutes: this.form.linkMicMinutes,
        guideMinutes: this.form.guideMinutes,
        rtcMaxResolution: this.form.rtcMaxResolution,
        multiplexingEnabled: this.boolToYn(this.form.multiplexingEnabled)
      };

      if (this.$refs.liveSystemSetting) {
        const result = this.$refs.liveSystemSetting.$getSettings();
        form = Object.assign(form, result);
      }

      if (form.chargeType === 'concurrent') {
        form.chargeType = this.concurrentType;
      }
      try {
        await this.$store.dispatch('account/updateLivePackage', form);
        this.$toast.success('保存成功');
        await this.getLivePackage();
      } finally {
        this.form.rtcMaxResolution = originalRtcMaxResolution;
        this.$emit('cancelLoading');
      }

    },
    async updateSuccess() {
      this.distributeDialogVisible = false;
      this.$toast.success('保存成功');
      await this.getLivePackage();
      // 后端重新设置有延迟
      setTimeout(async () => await this.$store.dispatch('account/getOverViewInfo'), 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.p-live-setting {
  padding: 0 18px;

  .p-live-setting__operate {
    margin: 20px 0;

    .plv-button {
      margin-right: 20px;
    }
  }

  .p-live-setting-form {
    width: 90%;

    ::v-deep .plv-checkbox {
      margin-bottom: 8px !important;
    }
  }

  .p-live-setting-form__title {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 20px;
    margin-top: 18px;
  }

  .p-live-setting-form-item__unit {
    margin-left: 8px;
  }

  .p-live-setting_btn {
    margin-top: 20px;
  }

  .plv-row--flex {
    align-items: center;
  }
}

.p-live-settings {
  position: relative;
  top: -30px;
}

.p-clear-continuous-wheat {
  display: flex;

  .p-checkbox-multiplexing {
    margin-left: 20px;
    margin-right: 0;
    width: 100px;
  }
}

.p-live-setting__column-item {
  height: 32px;
}
</style>
